import _map from 'lodash/map';
import _uniq from 'lodash/uniq';
import _filter from 'lodash/filter';
import { connect } from 'react-redux';
import SelectedGenerators from 'js/components/legacy/SelectedGenerators';

function mapPlotGeneratorsToParentPlotGeneratorsMap(plotGenerators) {
  return _filter(plotGenerators, 'parent');
}

function mapPlotGeneratorsToChildPlotGeneratorsMap(plotGenerators) {
  return _filter(plotGenerators, {
    parent: false
  });
}

export function mapPlotGeneratorsToGeneratorTypes(plotGenerators) {
  return _uniq(_map(plotGenerators, 'type'));
}
export default connect(function (state, ownProps) {
  return {
    plotParentGenerators: mapPlotGeneratorsToParentPlotGeneratorsMap(state.graphGeneratorData[ownProps.plotId]),
    plotChildGenerators: mapPlotGeneratorsToChildPlotGeneratorsMap(state.graphGeneratorData[ownProps.plotId]),
    plotGeneratorTypes: mapPlotGeneratorsToGeneratorTypes(state.graphGeneratorData[ownProps.plotId]),
    plotGenerators: state.graphGeneratorData[ownProps.plotId]
  };
})(SelectedGenerators);